import branches from './branch';
import orderRequest from './order';
import user from './user';
import orderRating from './rating';
import { localeStore } from 'src/mobx/localesStore';
import client from 'src/services/client';
import { ISettings } from 'src/types/app';
import { ICategoryWithProducts, IMenuProduct } from 'src/types/products';
import { IUser } from 'src/types/user';
import { productUtils } from '~/utils/productUtils';
import { ITranslationRelevanceParams, ITranslationRelevanceResponse } from '~/types/languageTranslation';
class Requests {
  branches = branches;
  user = user;
  order = orderRequest;
  orderRating = orderRating;

  fetchLocales = async (url: string, data: ITranslationRelevanceParams): Promise<ITranslationRelevanceResponse> => {
    const locale: ITranslationRelevanceResponse = await client.get(url, {
      params: data,
      headers: {
        'Accept-Language': data.language,
      },
    });
    return locale;
  };

  fetchAppSettings = async () => {
    const response: ISettings = await client.get(`/v3/app/settings`, { params: { language: localeStore.language } });
    return response;
  };

  fetchUser = async (): Promise<IUser> => {
    return await client.get('/v3/me');
  };

  fetchMenu = async (params: {
    search?: string;
    branch_id?: number;
    delivery_type?: 'd' | 'p';
    time?: number;
    menu_update?: number;
    global_category_id?: number;
    sort_products?: boolean;
  }): Promise<{ categories: ICategoryWithProducts[]; menu_update: number; global_category_id: number }> => {
    const response = await client.get(`/v3/categories/products`, {
      params,
    });
    const { menu_update, global_category_id, data } = response;
    const categories = data.map(_transformCategory);
    return { menu_update, global_category_id, categories };
  };

  fetchMenuPart = async (
    id: ICategoryWithProducts['id'],
    page: number,
    params: {
      search?: string;
      branch_id?: number;
      delivery_type?: 'd' | 'p';
      time?: number;
      menu_update?: number;
      global_category_id?: number;
      sort_products?: boolean | false;
    }
  ): Promise<ICategoryWithProducts['items']> => {
    const response = await client.get(`/v3/categories/${id}/products`, {
      params: {
        delivery_type: params.delivery_type,
        branch_id: params.branch_id,
        page,
        time: params.time,
        sort_products: true,
      },
    });
    return transformCategoryPagination(response);
  };

  fetchProduct = async (id: IMenuProduct['id'], branch_id: number = 0) => {
    const response = await client.get(`/v3/products/${id}`, { params: { branch_id } });
    return productUtils.transformProduct(response);
  };

  resendSMS = async (id: number | string | undefined, type: number) => {
    const response = await client.get(`/v3/orders/${String(id)}/resend-sms?type=${type}`);
    return response;
  };
}

export const requests = new Requests();

const _transformCategory = (category: any): ICategoryWithProducts => {
  return {
    ...category,
    items: transformCategoryPagination(category.items),
  };
};

const transformCategoryPagination = (items: any): ICategoryWithProducts['items'] => {
  return {
    ...items,
    loading: false,
    data: items.data.map((item: IMenuProduct) => productUtils.transformProduct(item)),
  };
};
